module.exports = __webpack_public_path__ + "img/elf-logo-mobile.bbff33b7.svg";